import LoadingAnimation from "@assets/svg/LoadingAnimation"
import StarFilledIcon from "@assets/svg/StarFilledIcon"
import AnimatedCircleProgress from "@components/AnimatedCircleProgress"
import AnimatedNumber from "@components/AnimatedNumber"
import { EnumJobStatus2, JobTypeEnum } from "@utils/constants"
import dayjs from "dayjs"
import { Check, StarIcon } from "lucide-react"
import { useState } from "react"
import { NavLink } from "react-router-dom"

const ApplicantCard = ({ data }) => {
    const [isMarkedFavorite, setIsMarkedFavorite] = useState(false)
    const [isMarking, setIsMarking] = useState(false)
  
    console.log('this is data', data)
    return (
        <NavLink
            to={'#'}
            // to={`/job-applicant-detail/${data?.jobId}`}
            state={{ item: data }}
            // onClick={onClick}
            className="grid grid-cols-[0.6fr_2fr_0.25fr] gap-20 items-center py-5 border-b pl-2 hover:bg-gray-50"
        >
            <div className="flex flex-col gap-3">
                <span className="text-xs font-medium text-primary bg-gray-50 rounded-md py-2 px-4 border text-center w-max">
                    {EnumJobStatus2[data?.jobDetails?.status]}
                </span>
                <div className="flex gap-3 pt-1 h-full">
                    {
                        data?.candidateDetails?.profilePic ?
                            <img
                                src={data?.candidateDetails?.profilePic}
                                className="h-11 w-11 rounded-full" />
                            : <div className="flex h-11 w-11 rounded-full bg-gray-100 border">
                                <span className="font-semibold text-lg text-light-black m-auto">{data?.candidateDetails?.firstName?.charAt(0)}</span>
                            </div>
                    }
                    <div className="flex flex-col gap-2.5">
                        <span className="font-medium text-light-black text-xs">{data?.candidateDetails?.refNo}</span>
                        <span className="font-bold text-primary text-xs">{data?.candidateDetails?.firstName} {data?.candidateDetails?.lastName}</span>
                        <span className="font-medium text-light-black text-xs">{JobTypeEnum[data?.jobDetails?.jobType]}</span>
                    </div>
                </div>
            </div>
            <div className="flex items-center gap-8 h-full w-full">
                <div className="flex flex-col gap-4 flex-1">
                    <span className="text-xs font-bold text-primary text-center">
                        {data?.jobDetails?.title}
                    </span>
                    <div className="flex flex-col gap-1.5">
                        <div className="flex items-center gap-5">
                            <span className="text-xs text-light-black italic">
                                {dayjs(data?.latestTracker?.updatedAt).format("hh:mm a")}
                            </span>
                            <span className="text-xs text-light-black italic">
                                {dayjs(data?.latestTracker?.updatedAt).format("DD MMM YYYY")}
                            </span>
                        </div>
                        <div className="flex flex-col border border-gray-200 bg-gray-50 rounded-md p-3 gap-1 h-[3.5rem] justify-center">
                            <span className="text-xs font-medium text-primary">
                                Latest Activity : {data?.latestTracker?.status}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col gap-3.5 h-full justify-end pb-3.5">
                    <span className="text-xs text-light-black">Agency</span>
                    <span className="text-xs font-medium text-primary">{data?.hiringCompany?.companyName || 'N/A'}</span>
                </div>
            </div>

            <div className="flex flex-col items-center h-full">
                <button
                    onClick={(e) => {
                        e?.preventDefault()
                        e?.stopPropagation()
                    }}
                    className="hover:bg-gray-100 rounded-full p-1.5 mr-4"
                >
                    {
                        isMarking ?
                            <LoadingAnimation color="#2e2e2e" /> :
                            isMarkedFavorite ?
                                <StarFilledIcon className={'h-6 w-6'} />
                                :
                                <StarIcon color="#2e2e2e" strokeWidth={1.5} />
                    }
                </button>
                <div className="flex flex-col h-full justify-end gap-3">
                    <span className="text-xs font-medium text-primary">Matched %</span>
                    <div className="relative">
                        <AnimatedCircleProgress progress={data?.matchingPercentage || 73} />
                    </div>
                </div>
            </div>
        </NavLink>
    );
    return <NavLink
        to={`/job-applicant-detail`}
        state={{
            item: data
        }}
        className="grid grid-cols-[1.3fr_2.5fr_0.42fr_0.42fr_0.42fr] gap-5 items-center justify-between bg-white border-b border-[#ececec] rounded px-2 py-5 hover:bg-gray-50 cursor-pointer"
    >
        <div className="flex gap-3 pt-1 h-full">
            {
                data?.candidateDetails?.profilePic ?
                    <img
                        src={data?.candidateDetails?.profilePic}
                        className="h-11 w-11 rounded-full" />
                    : <div className="flex h-11 w-11 rounded-full bg-gray-100 border">
                        <span className="font-semibold text-lg text-light-black m-auto">{data?.candidateDetails?.firstName?.charAt(0)}</span>
                    </div>
            }
            <div className="flex flex-col gap-2.5">
                <span className="font-medium text-light-black text-xs">{data?.candidateDetails?.refNo}</span>
                <span className="font-bold text-primary text-xs">{data?.candidateDetails?.firstName} {data?.candidateDetails?.lastName}</span>
                <span className="font-medium text-light-black text-xs">{data?.candidateDetails?.jobTitle || 'N/A'}</span>
            </div>
        </div>
        <div className="flex flex-col gap-1">
            <span className="font-medium text-xs italic text-light-black">{dayjs().format('hh:mm a DD MMM YY')}</span>
            <div className="flex flex-col justify-center border-2 rounded-md p-3 h-[3.8rem]">
                <span className="text-xs text-light-black font-medium">Applied: Joe Bloggs has applied for the job post <span className="font-bold text-primary">Cyber Security Manager</span></span>
            </div>
        </div>

        <div className="flex flex-col justify-end items-center h-full gap-2">
            <div className="h-[3.8rem] w-[3.8rem] rounded-full border-2 flex">
                <Check className="h-6 w-6 m-auto" stroke="gray" />
            </div>
        </div>
        <div className="flex flex-col justify-end items-center h-full gap-2">
            <AnimatedCircleProgress
                progress={20}
                size={63}
            />
        </div>
        <div className="flex flex-col justify-center items-center h-full gap-2">
            {/* <div className="h-[3.8rem] w-[3.8rem] rounded-full border-2 flex">
                <AnimatedNumber
                    value={data?.totalJobs || 0}
                    className="font-bold text-sm text-primary m-auto"
                />
            </div> */}
            <StarIcon size={40} className="mt-3" strokeWidth={1} stroke="gray" />
        </div>
    </NavLink>
}

export default ApplicantCard